import React, { useState } from 'react'
import getSortItems from '../../../functions/getSortItems'
import Button from '../../general/Button'
import EditAllMoviesListItem from './EditAllMoviesListItem'
import Translation from '../../Translation/cont/Translation'
import getEvenOddByIndex from '../../../functions/getEvenOddByIndex'

const EditAllMoviesListHeaderItem =({transId}) => (
    <div className="text-xsmall-light">
        <Translation id={transId} />
    </div>
)

const EditAllMoviesList = ({movies, moviesOrder, metaMovies, listHeaderRef, isSticky}) => {
    const checkList = [
        {
            transId: "movie_edit_movie_short_description",
            keys: ['descriptionShort'],
            check: 'notEmpty'
        },
        {
            transId: "movie_edit_movie_description",
            keys: ['description'],
            check: 'notEmpty'
        },
        {
            transId: "movie_attributes_fsk",
            keys: ['fsk'],
            check: 'fskExist'
        },
        {
            transId: "movie_attributes_length",
            keys: ['length'],
            check: 'notEmpty'
        },
        {
            transId: "movie_attributes_orig_title",
            keys: ['origTitle'],
            check: 'notEmpty'
        },
        {
            transId: "movie_edit_movie_trailer",
            keys: ['trailerURL'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_poster",
            keys: ['images', 'poster'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_ambient_image",
            keys: ['images', 'ambient'],
            check: 'notEmpty'
        },
        {
            transId: "images_movie_wallpapers",
            keys: ['images', 'backgrounds'],
            check: 'lengthNotZero'
        }
    ]

    const [sortList, setSortList] = useState('alphabetical')
    const moviesKeys = Object.keys(movies)
    const metaMoviesKeys = Object.keys(metaMovies)

    let sortedMovies
    let i = 0

    if('alphabetical' === sortList) {
        sortedMovies = getSortItems('title', 'alphabetical', moviesKeys, movies)
    } else if ('newest' === sortList) {
        sortedMovies = getSortItems('created_at', 'date', metaMoviesKeys, metaMovies)
    } else if ('sorting' === sortList) {
        sortedMovies =  moviesOrder
    }
    
    return (
        <div className="edit-all-movies-list">
            <div className="gap-20">
                <h3  className="gap-20 title-list text-regular">Liste sortieren nach:</h3>
                <Button
                    className="button-small button-sort-list"
                    transId="alphabetical"
                    hideText={false}
                    disabled={'alphabetical' === sortList}
                    onClick={() => setSortList('alphabetical')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="newest"
                    hideText={false}
                    disabled={'newest' === sortList}
                    onClick={() => setSortList('newest')}
                />
                <Button
                    className="button-small button-sort-list"
                    transId="movie_sorting"
                    hideText={false}
                    disabled={'sorting' === sortList}
                    onClick={() => setSortList('sorting')}
                />
            </div>

            <div className={"liste-header container-checks" + (isSticky ? ' is-sticky' : '')} ref={listHeaderRef}>
                {checkList.map(({transId}, index) => (
                    <EditAllMoviesListHeaderItem 
                        key={index} 
                        transId={transId}
                    />
                ))}
            </div>

            <ul className="list-main">
                {sortedMovies.map(moviePk => {

                    if(movies.hasOwnProperty(moviePk)) {
                        i++

                        return <EditAllMoviesListItem 
                            key={moviePk}
                            itemData={movies[moviePk]}
                            checkList={checkList}
                            evenOddClass={getEvenOddByIndex(i)}
                        />

                    } else {
                        return ''
                    }
                })}
            </ul>
        </div>
    )
}

export default EditAllMoviesList